// src/components/ads-admin/ProviderCard.jsx
import React from "react";
import Chip from "./Chip";
import { fmtDt, toneFromStatus } from "./utils";

export default function ProviderCard({
  title,
  subtitle,
  icon,
  selected,
  onSelect,
  configuredTone,
  configuredLabel,
  activeCount,
  validatedCount,
  lastRun,
  disabled,
  onManageAdvertisers,
  onRunNow,
  onBrowseAds,
}) {
  const statusTone = toneFromStatus(lastRun?.status);
  const border = selected ? "2px solid #1d4ed8" : "1px solid rgba(15,23,42,0.10)";
  const bg = selected ? "linear-gradient(180deg, #ffffff, #f8fafc)" : "#fff";

  const gateOk = validatedCount > 0;

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={() => {
        if (disabled) return;
        onSelect?.();
      }}
      onKeyDown={(e) => {
        if (disabled) return;
        if (e.key === "Enter" || e.key === " ") onSelect?.();
      }}
      style={{
        border,
        borderRadius: 16,
        padding: 14,
        background: bg,
        boxShadow: selected ? "0 16px 30px rgba(29,78,216,0.10)" : "0 10px 24px rgba(15,23,42,0.06)",
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.55 : 1,
        display: "grid",
        gap: 10,
      }}
      title="Click to select this provider"
    >
      <div style={{ display: "flex", gap: 12, alignItems: "flex-start", justifyContent: "space-between" }}>
        <div style={{ display: "flex", gap: 10, alignItems: "flex-start" }}>
          <div
            aria-hidden="true"
            style={{
              width: 34,
              height: 34,
              borderRadius: 12,
              display: "grid",
              placeItems: "center",
              background: "rgba(15,23,42,0.05)",
              border: "1px solid rgba(15,23,42,0.08)",
              fontSize: 18,
            }}
          >
            {icon}
          </div>
          <div>
            <div style={{ fontWeight: 950, color: "#0f172a", fontSize: 14 }}>{title}</div>
            <div style={{ fontSize: 12, color: "#6b7280", fontWeight: 700, lineHeight: 1.35 }}>{subtitle}</div>
          </div>
        </div>

        <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap", justifyContent: "flex-end" }}>
          <Chip tone={configuredTone}>{configuredLabel}</Chip>
          {selected && <Chip tone="info">Selected</Chip>}
        </div>
      </div>

      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
        <Chip tone={gateOk ? "success" : "warn"}>
          Gate: {gateOk ? "OK" : "Needs validation"} ({validatedCount}/{activeCount} validated)
        </Chip>
        {lastRun?.id ? (
          <>
            <Chip tone={statusTone}>
              Last run #{lastRun.id}: {lastRun.status || "—"}
            </Chip>
            <Chip tone="neutral">{fmtDt(lastRun.completed_at || lastRun.started_at)}</Chip>
          </>
        ) : (
          <Chip tone="neutral">No runs yet</Chip>
        )}
      </div>

      <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginTop: 4 }}>
        <button
          className="btn-primary"
          onClick={(e) => {
            e.stopPropagation();
            onManageAdvertisers?.();
          }}
          style={{ padding: "10px 14px", borderRadius: 12 }}
          disabled={disabled}
        >
          Manage advertisers
        </button>

        <button
          className="btn-secondary"
          onClick={(e) => {
            e.stopPropagation();
            onRunNow?.();
          }}
          style={{ padding: "10px 14px", borderRadius: 12 }}
          disabled={disabled || !gateOk}
          title={gateOk ? "Create + execute ingestion run" : "Blocked: you need at least 1 validated advertiser"}
        >
          Run now
        </button>

        <button
          className="btn-secondary"
          onClick={(e) => {
            e.stopPropagation();
            onBrowseAds?.();
          }}
          style={{ padding: "10px 14px", borderRadius: 12 }}
          disabled={disabled || !lastRun?.id}
          title={lastRun?.id ? "Jump to browsing" : "No runs yet"}
        >
          Browse
        </button>
      </div>

      <div style={{ fontSize: 12, color: "#6b7280", fontWeight: 700, lineHeight: 1.45 }}>
        <span style={{ fontWeight: 900, color: "#0f172a" }}>One-click principle:</span> select provider → manage advertisers → validate → run.
      </div>
    </div>
  );
}